export const API_ROUTES = {
  AUTHENTICATE: '/iam/auth/authenticate',
  REFRESH_TOKEN: '/iam/auth/login/token',
  LOGOUT: '/iam/auth/logout',

  ACCOUNT: '/iam/accounts/me',

  // GET_INVOICES: '/balance/invoices/me',
  POST_INVOICE: '/balance/invoices',

  GET_WALLETS: '/balance/wallets/me',
  GET_TRANSACTIONS: '/balance/transactions/me',

  GET_GATEWAYS: '/balance/gateways',

  GET_PAYMENT_METHODS: '/balance/payment-methods',

  EXECUTE_PAYMENTS: '/balance/payments/execute',

  EXCHANGE_RATE: '/balance/exchange/rate',

  GET_CHART_STATISTICS: '/pool/statistics/chart',

  GET_TABLE_STATISTICS: '/pool/statistics/table',

  GET_STATISTICS: '/pool/statistics/me',

  GET_USER_PROFILE: '/profile',

  // NEW API
  GET_USER_DATA: 'user',
  UPDATE_USER_DATA: 'user/update',
  UPDATE_USER_WALLET: 'users/btc-wallet-address',
  CALCULATIONS: 'calculations',

  LOCATIONS: 'location/calculations',

  GET_MINERS_DATA: 'miner',
  UPDATE_MINER_DATA: 'miner/name',

  GET_CHARTS_DATA: 'statistics',

  GET_ELECTRICITY_COST_TRANSACTIONS: 'electricitycosttransaction',
  GET_FIAT_TRANSACTIONS: 'fiattransaction',

  GET_BTC_RATE: 'btc',

  CREATE_POOL: 'poolconfiguration',
  CREATE_POOL_VIA_BTC: 'viabtc/config',
  CREATE_POOL_POWERPOOL: 'powerpool/config',
  CREATE_OURPOOL: 'users/btc-wallet-address',

  CREATE_CRYPTO_PAYMENT: 'confirmo/create',
  CREATE_FIAT_PAYMENT: 'payments/create',
  CREATE_STRIPE_PAYMENT: 'stripe/payment',

  GET_INVOICES: 'invoice',

  GET_MY_TASKS: 'tasks/my-tasks',

  GET_BILLING_STATUS: 'users/billing-status',
  UPDATE_LOW_BALANCE_THRESHOLD: 'users/low-balance-threshold',
  GET_MY_STATEMENT: 'users/statement',
  GET_MY_UPTIME: 'users/uptime',

  AUTO_TOPUP: 'payments/auto-topup',
  AUTO_TOPUP_SETUP: 'payments/auto-topup/setup',

  ANNOUNCEMENTS: 'announcements',
  GET_ACTIVE_ANNOUNCEMENTS: 'announcements/active',

  GET_PRODUCTS_DATA: 'products',

  SIGN_CONTRACT: 'contracts/sign',

  // Plan 06: org feature flags (fetched once at login into the `features` slice).
  GET_FEATURES: 'features',
};
